import { makeAutoObservable } from 'mobx'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import type { Inbox } from 'entities/Inbox/model/Inbox'
import { type GroupInbox } from 'entities/Inbox/model/GroupInbox'
import type { ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

export class SharedApiMenuStore {
  constructor(
    private _conversationMenuStore: ConversationMenuStore,
    private _entities: IEntitiesStore
  ) {
    makeAutoObservable(this)
  }

  onMute = async (inbox: Inbox) => {
    await this._entities.inboxesStore.handleUpdateTeamsMute(inbox, !inbox.isMuted)
    this._conversationMenuStore.syncInboxesTree()
  }

  onRename = (inbox: GroupInbox) => {
    this._entities.inboxesStore.groupInboxStore.toggleRenameMode(inbox, true)
  }
}
